<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M3.25 10.7583L3.9771 9.02207C4.24563 8.38079 5.16101 8.41613 5.37983 9.07622L6.26546 11.7476C6.49566 12.442 7.47571 12.4327 7.69284 11.7341L9.93213 4.5292C10.1598 3.79674 11.2032 3.83442 11.3781 4.58141L13.9141 15.4186C14.0856 16.1516 15.1022 16.2069 15.3514 15.4968L16.75 11.5124" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'TrendIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>